export enum HttpRequestType {
    Get = 'GET',
    Post = 'POST',
    Put = 'PUT',
    Delete = 'DELETE'
}

export enum NetworkProtocol {
    Http = 'http',
    Https = 'https',
    Ftp = 'ftp'
}
